import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {GameCenterContainerController} from "../game-center-container.controller";
import React from "react";
import {EntityMegaHeaderModuleAsync} from "../../../apps/website/modules/entity-mega-header-module/components/entity-mega-header-module.async";
import {ENTITY_MEGA_HEADER} from "../../../apps/website/modules/entity-mega-header-module/entity-mega-header-module.consts";
import {NAVIGATION_TABS_CONTEXT} from "../../../core/app/consts";
import {Breadcrumbs} from "../../../core/components/breadcrumbs/breadcrumbs";
import {GameCenterContainerExternalAd} from "./game-center-container.external-ad";
import {GameCenterContainerGamesSuggestions} from "./game-center-container.games-suggestions";
import {SkyScrapperWrapper} from "../../../core/components/sky-scrapper/sky-scrapper.wrapper";
import {GameCenterContainerContent} from "./game-center-container.content";
import {SKY_SCRAPPER_OFFSET} from "../../../core/consts";

export class GameCenterContainerComponentProps extends BaseModuleProps {}

export const GameCenterContainerComponent = ({controller, scrollToTop}) => {
  const {state, device} = controller;
  const {page, descriptionHeader, competitionViewModel, hasBreadcrumbs, shouldRenderAdsBorders} = state;
  const {isSmallView} = device;

  const megaHeaderProps = {
    page,
    descriptionHeader,
    entity: competitionViewModel,
    entityType: ENTITY_MEGA_HEADER.ENTITY_TYPES.competition,
    tabsContext: NAVIGATION_TABS_CONTEXT.competition,
  }

  const breadcrumbsProps = {
    controller,
    visible: true,
    hasData: hasBreadcrumbs
  }

  return (
    <>
      <GameCenterContainerGamesSuggestions controller={controller}/>
      <Breadcrumbs {...breadcrumbsProps}/>
      {
        !isSmallView ? <EntityMegaHeaderModuleAsync {...megaHeaderProps}/> : null
      }
      <GameCenterContainerExternalAd controller={controller}/>
      {
        shouldRenderAdsBorders ? <SkyScrapperWrapper controller={controller} top={SKY_SCRAPPER_OFFSET.entityPage}>
          <GameCenterContainerContent controller={controller} scrollToTop={scrollToTop}/>
        </SkyScrapperWrapper> : <GameCenterContainerContent controller={controller} scrollToTop={scrollToTop}/>
      }
    </>
  )
}

const settings: ComposeSettings = {
  component: GameCenterContainerComponent,
  propsType: GameCenterContainerComponentProps,
  controllerType: GameCenterContainerController,

  useMetadata: true,
  filterRoute: true,
  observe: true,
  createModule: true,
}

export const GameCenterContainer = Compose(settings);

export default GameCenterContainer;
